/* Mikaya — cart upsell loader. Fetches Shopify product recommendations
   (complementary, falling back to related) and renders compact +Add cards. */
(function () {
  // Reveal the server-rendered fallback so the upsell is never empty.
  function useFallback(el, row) {
    var tpl = el.querySelector('[data-mk-upsell-fallback]');
    var html = tpl ? (tpl.innerHTML || (tpl.content ? tpl.content.firstElementChild && tpl.innerHTML : '')) : '';
    if (tpl && tpl.content) {
      var wrap = document.createElement('div');
      wrap.appendChild(tpl.content.cloneNode(true));
      html = wrap.innerHTML;
    }
    if (html && html.indexOf('mk-upsell-card') !== -1) {
      row.innerHTML = html;
      el.classList.remove('is-empty');
      el.dataset.mkLoaded = '1';
    } else {
      el.classList.add('is-empty');
    }
  }

  function loadOne(el) {
    if (el.dataset.mkLoaded === '1') return;
    var row = el.querySelector('[data-mk-upsell-row]');
    if (!row) return;

    // Try each cart product in turn (resilient: some products have no recs).
    var ids = (el.getAttribute('data-product-ids') || el.getAttribute('data-product-id') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!ids.length) { useFallback(el, row); return; }

    function fetchFor(idIndex, intent) {
      if (idIndex >= ids.length) { useFallback(el, row); return; }
      var pid = ids[idIndex];
      var url = '/recommendations/products?product_id=' + encodeURIComponent(pid) +
        '&intent=' + intent + '&limit=4&section_id=mk-cart-recommendations';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var list = tmp.querySelector('[data-upsell-list]');
          var count = list ? list.querySelectorAll('.mk-upsell-card').length : 0;
          if (list && count > 0) {
            row.innerHTML = list.innerHTML;
            el.classList.remove('is-empty');
            el.dataset.mkLoaded = '1';
            return;
          }
          if (intent === 'complementary') { fetchFor(idIndex, 'related'); }
          else { fetchFor(idIndex + 1, 'complementary'); }
        })
        .catch(function () {
          if (intent === 'complementary') { fetchFor(idIndex, 'related'); }
          else if (idIndex + 1 < ids.length) { fetchFor(idIndex + 1, 'complementary'); }
          else { useFallback(el, row); }
        });
    }
    fetchFor(0, 'complementary');
  }

  function init() {
    document.querySelectorAll('[data-mk-upsell]').forEach(loadOne);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-init after AJAX cart updates (drawer re-rendered)
  document.addEventListener('mk:cart:updated', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:section:load', init);
})();
